import React, { useState, useEffect } from "react";
import ImagePreview from "../ImagePreview";
import { Tooltip, Pagination } from "antd";
import { useSelector } from 'react-redux';
import { selectCurrentPlan } from '../../redux/selectors/authSelectors';
import { FEATURE_REQUIRED_PLANS } from '../../utils/planFeatureAccess';
import UpgradePromptModal from '../../components/common/UpgradePromptModal';

// import { GrFormView } from "react-icons/gr";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";

import {
  ActionEye,
  ActionSend,
  DeleteBin,
  DeleteIcon,
  EditPencil,
  ImageIcon,
  PdfAttachmentIcon,
  ProgressIcon,
  StatsIcon,
} from "../../assets/icons";
import DataGridSkeleton from "./DataGridSkeleton.js";
import { Modal } from "@mui/material";
import { formatAmount } from "../../utils/numberUtils";
import DailyStatsCalendar from "../../pages/Workers/DailyStatsCalendar.js";
import DailyStats from "../../pages/Workers/DailyStats.js";
import { IMAGE_BASE_URL } from "../../config/api.js";
import { CustomToast } from "../toastMessage/index.js";
import { deleteVendor, deleteWorker, deleteTask, deleteProject, deleteExpense } from "../../services/service.js";
import ConfirmationModal from "../ConfirmationModal/index.jsx";
import { toast } from "react-toastify";
import ImageSlider from "../../components/common/ImageSlider";

const DG = ({ index, loader, data, getData, setFilterState, handleEdit, pagination, onPageChange, hideActions, toolbar, enableCheckboxSelection = false, rowSelectionModel = [], onRowSelectionModelChange, disableRowSelectionOnClick = false, isSuperAdmin = false }) => {
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStatsOpen, setIsStatsOpen] = useState(false);
  const [selectedWorkerId, setSelectedWorkerId] = useState(null);
  const [previewData, setPreviewData] = useState({
    image: null,
    video: null,
    description: "",
    userProfile: null,
    userName: "",
    storyTime: null,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [deleteState, setDeleteState] = useState(null);
  const [open, setOpen] = useState(false);

  const [showImageSlider, setShowImageSlider] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const currentPlan = useSelector(selectCurrentPlan);

  const canAccessFeature = (feature) => {
    const planLevels = {
      'trial': 0,
      'basic': 1,
      'premium': 2,
      'ultimate': 3
    };
    return planLevels[currentPlan] >= planLevels[FEATURE_REQUIRED_PLANS[feature]];
  };

  const handleOpen = (workerId) => {
    setSelectedWorkerId(workerId);
    setOpen(true);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);

      switch (index) {
        case 5:
          await deleteExpense(deleteState);
          toast.success("Expense deleted successfully");
          closeModal();
          getData && getData();
          break;
        case 4:
          await deleteWorker(deleteState);
          toast.success("Worker deleted successfully");
          closeModal();
          getData();
          navigate("/view-worker");
          break;
        case 6:
          await deleteTask(deleteState);
          toast.success("Task deleted successfully");
          closeModal();
          getData();
          break;
        case 9:
          await deleteVendor(deleteState);
          toast.success("Vendor deleted successfully");
          closeModal();
          getData();
          navigate("/view-vendor");
          break;
        case 3:
          await deleteProject(deleteState);
          toast.success("Project deleted successfully");
          closeModal();
          getData();
          break;
        default:
          toast.info("No action for this index");
          break;
      }
    } catch (error) {
      console.error("Error deleting item", error);
      toast.error("Error deleting item");
    } finally {
      setDeleteModal(false);
      setIsLoading(false);
    }
  };

  const handleWorkerDetails = (workerId) => {
    navigate(`/worker-details/${workerId}`, { state: { workerId: workerId } });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const handleProjectView = (id) => {
    if (isSuperAdmin) {
      navigate(`/super-admin/project-details/${id}`);
    } else {
      navigate("/project-details", { state: { projectId: id } });
    }
  };

  const handleSend = (id) => {
    navigate("/project-progress", { state: { projectId: id } });
  };

  const handleInvoiceView = (invoiceImage) => {
    setPreviewData((prev) => ({
      ...prev,
      image: invoiceImage,
      description: "",
    }));
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPreviewData({
      image: null,
      video: null,
      description: "",
      userProfile: null,
      userName: "",
      storyTime: null,
    });
  };

  const handleProgressEyeClick = (id) => {
    navigate("/worker-progress", { state: { workerId: id } });
  };
  const handleEditWorkerClick = (id) => {
    navigate("/add-worker", { state: { workerId: id } });
  };

  const handleEditVendorClick = (id) => {
    navigate("/add-vendor", { state: { vendorId: id } });
  };

  const handleShowImages = (attachments) => {
    if (attachments?.length > 0) {
      // Filter only image attachments
      const imageAttachments = attachments.filter(att =>
        att.type.startsWith('image/')
      );
      if (imageAttachments.length > 0) {
        setSelectedImages(imageAttachments);
        setShowImageSlider(true);
      }
    }
  };

  const handleStatsClick = (workerId) => {
    if (!canAccessFeature('workerStats')) {
      setShowUpgradeModal(true);
      return;
    }
    handleOpen(workerId);
  };

  const handleEditProject = (id) => {
    navigate("/add-project", { state: { projectId: id, isEdit: true } });
  };

  const RecentProjects = [
    {
      field: "project",
      headerName: "Project",
      flex: 1.5,
      sortable: false,
      // align: "center",
      // headerAlign: "center",
    },
    {
      field: "client",
      headerName: "Client Name",
      flex: 2.5,
      sortable: false,
      // align: "center",
      // headerAlign: "center",
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1.5,
      sortable: false,
      // align: "center",
      // headerAlign: "center",
    },
    {
      field: "project_status",
      headerName: "Status",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const rawStatus = params.row.project_status || "-";
        const projectStatus = rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase();
        let colorClass = "bg-gray-100 text-gray-800";
        if (projectStatus === "Active") {
          colorClass = "bg-green-100 text-green-800";
        } else if (projectStatus === "Completed") {
          colorClass = "bg-green-100 text-green-800";
        } else if (projectStatus === "Inactive") {
          colorClass = "bg-red-100 text-red-800";
        }

        return (
          <span
            className={`px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}
          >
            {projectStatus}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Details">
            <span onClick={handleProjectView}>{ActionEye}</span>
          </Tooltip>
          <Tooltip title="Send Progress">
            <span>{ActionSend}</span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const Projects = [
    {
      field: "project",
      headerName: "Project",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "client",
      headerName: "Client Name",
      flex: 2.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "organization",
      headerName: "Organization",
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "workerCount",
      headerName: "Workers",
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => params.row.workerCount ?? 0,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const rawProjectStatus = (params.row.project_status || "").toString().trim();
        let projectStatus = "-";

        if (rawProjectStatus) {
          projectStatus =
            rawProjectStatus.charAt(0).toUpperCase() +
            rawProjectStatus.slice(1).toLowerCase();
        } else if (!isSuperAdmin) {
          // Frontend fallback for manager/org project list when backend does not send project_status.
          const fallbackStatus = params.row.status;
          if (typeof fallbackStatus === "string" && fallbackStatus.trim()) {
            projectStatus = fallbackStatus;
          } else if (fallbackStatus === true || fallbackStatus === 1) {
            projectStatus = "Active";
          } else if (fallbackStatus === false || fallbackStatus === 0) {
            projectStatus = "Inactive";
          }
        }

        let colorClass = "bg-gray-100 text-gray-800";
        if (projectStatus === "Active") {
          colorClass = "bg-green-100 text-green-800";
        } else if (projectStatus === "Completed") {
          colorClass = "bg-green-100 text-green-800";
        } else if (projectStatus === "Inactive") {
          colorClass = "bg-red-100 text-red-800";
        }

        return (
          <span
            className={`px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}
          >
            {projectStatus}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: isSuperAdmin ? 1 : 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Details">
            <span onClick={() => handleProjectView(params.row.id)}>
              {ActionEye}
            </span>
          </Tooltip>
          {!isSuperAdmin && (
            <>
              <Tooltip title="Edit Project">
                <span onClick={() => handleEditProject(params.row.id)}>
                  {EditPencil}
                </span>
              </Tooltip>
              <Tooltip title="Send Progress">
                <span onClick={() => handleSend(params.row.id)}>{ActionSend}</span>
              </Tooltip>
              <Tooltip title="Delete Project">
                <span
                  onClick={() => {
                    setDeleteModal(true);
                    setDeleteState(params?.row?.id);
                  }}
                >
                  {DeleteBin}
                </span>
              </Tooltip>
            </>
          )}
        </div>
      ),
    },
  ];

  const RecentWorkers = [
    {
      field: "name",
      headerName: "Name",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 2.5,
      sortable: false,
      align: "center",
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "assignProject",
      headerName: "Assigned Project",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "assignTask",
      headerName: "Assigned Task",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "yearsOfExperience",
      headerName: "Years of Experience",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "projectsWorkedOn",
      headerName: "Projects Worked On",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "expertise",
      headerName: "Expertise",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
    },
    {
      field: "gender",
      headerName: "Gender",
      flex: 1,
      sortable: false,
      align: "center",
    },
    {
      field: "bio",
      headerName: "Bio",
      flex: 2,
      sortable: false,
      align: "center",
    },
    {
      field: "progress",
      headerName: "Progress",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: () => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Progress">
            <span>{ActionEye}</span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "stats",
      headerName: "Daily Stats",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: () => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Stats">
            <span>{ActionEye}</span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: () => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="Edit Worker">
            <span>{EditPencil}</span>
          </Tooltip>
          <Tooltip title="Delete Worker">
            <span>{DeleteBin}</span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const Workers = [
    {
      field: "name",
      headerName: "Name",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    // {
    //   field: "assignProject",
    //   headerName: "Assigned Project",
    //   flex: 1.5,
    //   sortable: false,
    //   align: "center",
    // },
    {
      field: "expertise",
      headerName: "Expertise",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
    },

    {
      field: "progress",
      headerName: "Progress",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Progress">
            <span onClick={() => handleProgressEyeClick(params.row.id)}>
              {ProgressIcon}
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "stats",
      headerName: "Daily Stats",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title={!canAccessFeature('workerStats') ? "Upgrade to Basic Plan" : "View Stats"}>
            <span
              onClick={() => handleStatsClick(params.row.id)}
              className={!canAccessFeature('workerStats') ? 'opacity-50' : ''}
            >
              {StatsIcon}
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="View Details">
            <span onClick={() => handleWorkerDetails(params.row.id)}>
              {ActionEye}
            </span>
          </Tooltip>
          <Tooltip title="Edit Worker">
            <span onClick={() => handleEditWorkerClick(params.row.id)}>
              {EditPencil}
            </span>
          </Tooltip>
          <Tooltip title="Delete Worker">
            <span
              onClick={() => {
                setDeleteModal(true);
                setDeleteState(params?.row?.id);
              }}
            >
              {DeleteBin}
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const Expenses = [
    {
      field: "period",
      headerName: "Period",
      flex: 1.2,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "project",
      headerName: "Project",
      flex: 1.5,
      sortable: false,
      align: "left",
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      sortable: false,
      align: "left",
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1.2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => formatAmount(params.row.amount),
    },
    {
      field: "tax",
      headerName: "Tax",
      flex: 0.8,
      sortable: false,
      align: "center",
      headerAlign: "center",
      // Show tax amount under Tax column
      renderCell: (params) => params.row.tax_amount ?? "-",
    },
    {
      field: "total_amount",
      headerName: "Total Amount",
      flex: 1.2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => formatAmount(params.row.total_amount),
    },
    {
      field: "vendors",
      headerName: "Vendor",
      flex: 1.3,
      sortable: false,
      align: "left",
    },
    {
      field: "image",
      headerName: "Invoice",
      flex: 0.8,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const invoiceImage = params.row.image;
        if (!invoiceImage) {
          return (
            <div className="cursor-default ml-2 flex items-center justify-center">
              <span className="text-gray-400 text-xs">No file</span>
            </div>
          );
        }

        // Check if it's a PDF file
        const isPdf = typeof invoiceImage === 'string' && invoiceImage.toLowerCase().includes('.pdf');
        const fileUrl = IMAGE_BASE_URL + invoiceImage;

        const handleFileClick = () => {
          if (isPdf) {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
          } else {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
          }
        };

        return (
          <div
            className="cursor-pointer ml-2 flex items-center justify-center hover:opacity-70 transition-opacity"
            onClick={handleFileClick}
            title={isPdf ? "Click to view PDF" : "Click to view image"}
          >
            {isPdf ? (
              <div className="text-red-600">
                {PdfAttachmentIcon}
              </div>
            ) : (
              <div className="text-blue-600">
                {ImageIcon}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const role = params.row.created_by_role;
        if (!role) return "-";
        return (
          <span className="capitalize">
            {role}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-3">
          <Tooltip title="View Details">
            <span
              onClick={() => {
                navigate("/expense-details", {
                  state: { expenseData: params.row },
                });
              }}
            >
              {ActionEye}
            </span>
          </Tooltip>
          <Tooltip title="Edit Expense">
            <span
              onClick={() => {
                if (handleEdit) {
                  handleEdit(params.row);
                }
              }}
            >
              {EditPencil}
            </span>
          </Tooltip>
          <Tooltip title="Delete Expense">
            <span
              onClick={() => {
                setDeleteModal(true);
                setDeleteState(params?.row?.id);
              }}
            >
              {DeleteBin}
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const Tasks = [
    {
      field: "name",
      headerName: "Task Name",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "attachment",
      headerName: "Attachment",
      flex: 1.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title={`View Attachments (${params.row.attachements?.length || 0})`}>
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleShowImages(params.row.attachements);
              }}
            >
              {ImageIcon}
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="Edit Task">
            <span
              onClick={(e) => {
                e.stopPropagation();
                if (handleEdit) {
                  handleEdit(params.row);
                }
              }}
            >
              {EditPencil}
            </span>
          </Tooltip>
          <Tooltip title="Delete Task">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setDeleteModal(true);
                setDeleteState(params?.row?.id);
              }}
            >
              {DeleteBin}
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  //Vendor

  const Vendor = [
    {
      field: "name",
      headerName: "Vendor Name",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "lat",
      headerName: "Lat",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "long",
      headerName: "Long",
      flex: 1.5,
      sortable: false,
      // align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: 1.5,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="cursor-pointer ml-2 flex items-center gap-2">
          <Tooltip title="Edit Vendor">
            <span onClick={() => handleEditVendorClick(params.row.id)}>
              {EditPencil}
            </span>
          </Tooltip>
          <Tooltip title="Delete Vendor">
            <span
              onClick={() => {
                setDeleteModal(true);
                setDeleteState(params?.row?.id);
              }}
            >
              {DeleteBin}
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const OrganizationMembers = [
    {
      field: "username",
      headerName: "Name",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 2,
      sortable: false,
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "joinedDate",
      headerName: "Joined Date",
      flex: 1.5,
      sortable: false,
      align: "left",
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cursor-pointer ml-2 flex items-center gap-3">
            <Tooltip title="Edit Manager">
              <span onClick={() => handleEdit?.(params.row)}>
                {EditPencil}
              </span>
            </Tooltip>
            {!params.row.is_admin && (
              <Tooltip title="Delete Manager">
                <span
                  onClick={() => {
                    getData(params?.row);
                  }}
                >
                  {DeleteBin}
                </span>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const loadTable = () => {
    setLoading(true);
    switch (index) {
      case 1:
        setColumns(RecentProjects);
        setRows(
          data?.map((item) => ({
            id: item.id,
            project: item.project,
            client: item.client,
            startdate: item.startdate,
            location: item.location,
            budget: item.budget,
            completionDate: item.completionDate,
            description: item.description,
            progressPhotos: item.progressPhotos,
            taskPercentage: item.taskPercentage,
            status: item.status,
            project_status: item.project_status,
          }))
        );
        break;

      case 2:
        setColumns(RecentWorkers);
        setRows(
          data?.map((item) => ({
            id: item.id,
            
            name: item.username,
            email: item.email,
            phone: item.phone,
            assignProject: item.assignProject,
            assignTask: item.assignTask,
            yearsOfExperience: item.yearsOfExperience,
            projectsWorkedOn: item.projectsWorkedOn,
            expertise: item.expertise,
            gender: item.gender,
            bio: item.bio,
          }))
        );
        break;
      case 3:
        setColumns(Projects);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            project: item?.title,
            client: item?.Client?.username,
            organization:
              item?.organization_name ||
              item?.organization?.title ||
              item?.organization?.name ||
              item?.Organization?.title ||
              item?.Organization?.name ||
              item?.org_name ||
              "N/A",
            workerCount: Number(item?.worker_count) || 0,
            startdate: item?.startdate,
            location: item?.address,
            budget: item?.budget,
            completionDate: item?.completionDate,
            description: item?.description,
            progressPhotos: item?.progressPhotos,
            taskPercentage: item?.taskPercentage,
            project_status: item?.project_status,
            status: (() => {
              const rawProjectStatus = (item?.project_status || "").toString().trim().toLowerCase();
              if (rawProjectStatus === "active") return "Active";
              if (rawProjectStatus === "inactive") return "Inactive";
              if (rawProjectStatus === "completed") return "Completed";

              if (item?.status === true || item?.status === 1) return "Active";
              if (item?.status === false || item?.status === 0) return "Inactive";

              if (item?.is_active === true || item?.is_active === 1) return "Active";
              if (item?.is_active === false || item?.is_active === 0) return "Inactive";

              if (item?.recent_active === true || item?.recent_active === 1) return "Active";
              if (item?.recent_active === false || item?.recent_active === 0) return "Inactive";

              // Unknown status should not be forced to Inactive.
              return "";
            })(),
          }))
        );
        break;

      case 4:
        setColumns(Workers);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            name: item?.username,
            email: item?.email,
            phone: item?.phoneNo,
            assignProject: item?.assignProject,
            assignTask: item?.assignTask,
            yearsOfExperience: item?.experience,
            projectsWorkedOn: item?.numOfProjects,
            expertise: item?.expertise,
            gender: item?.gender,
            bio: item.bio,
          }))
        );
        break;

      case 5:
        setColumns(Expenses);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            description: item?.description,
            project: item?.project?.title || item?.project_id,
            task: item?.task_id,
            amount: item?.input_amount,
            period: item?.invoice_date?.slice(0, 10),
            vendors: item?.vendor?.title,
            image: item?.invoice_image,
            tax: item?.tax_rate,
            tax_amount: item?.tax_amount,
            total_amount: item?.amount,
            created_by_role: item?.ExpenseCreator?.role,
            original: item,
          }))
        );
        break;

      case 6:
        setColumns(Tasks);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            name: item?.title,
            description: item?.task_description || "Description",
            project_id: item?.project_id,
            // attachments: item?.images || [],
            attachements: item?.TaskAttachments || [],
          }))
        );
        break;

      case 9:
        setColumns(Vendor);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            name: item?.title,
            address: item?.vendorAddress?.[0]?.address,
            phone: item?.phoneNo,
            email: item?.email,
            lat: item?.vendorAddress?.[0]?.latitude || item?.latitude,
            long: item?.vendorAddress?.[0]?.longitude || item?.longitude,
          }))
        );
        break;

      case 10: // Organizations
        const OrganizationsColumns = [
          {
            field: "id",
            headerName: "ID",
            flex: 0.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
          {
            field: "title",
            headerName: "Organization Name",
            flex: 2,
            sortable: false,
            align: "left",
          },
          {
            field: "plan",
            headerName: "Plan",
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const planName = params.row.plan;
              let colorClass = "bg-gray-100 text-gray-800";
              if (planName === "ULTIMATE") {
                colorClass = "bg-purple-100 text-purple-800";
              } else if (planName === "PREMIUM") {
                colorClass = "bg-blue-100 text-blue-800";
              } else if (planName === "BASIC") {
                colorClass = "bg-green-100 text-green-800";
              }
              return (
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}>
                  {planName}
                </span>
              );
            },
          },
          {
            field: "status",
            headerName: "Status",
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const status = params.row.status;
              const isActive = status === "ACTIVE" || status === "active" || status === "Active";
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${isActive
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                    }`}
                >
                  {isActive ? "Active" : "Deactivated"}
                </span>
              );
            },
          },
          {
            field: "plan_changed_by",
            headerName: "Plan Changed By",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const changedBy = params.row.plan_changed_by;
              if (!changedBy) {
                return <span className="text-gray-400 text-xs">N/A</span>;
              }
              // Format the text: replace underscores with spaces and capitalize
              const formattedText = changedBy
                .replace(/_/g, " ")
                .split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(" ");
              const isSuperAdmin = formattedText.toLowerCase().includes("super admin");
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${isSuperAdmin
                    ? "bg-blue-100 text-blue-800"
                    : "bg-purple-100 text-purple-800"
                    }`}
                >
                  {formattedText}
                </span>
              );
            },
          },
          {
            field: "subscriptionEnd",
            headerName: "Subscription End",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
          {
            field: "createdAt",
            headerName: "Created Date",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
        ];
        setColumns(OrganizationsColumns);
        setRows(data);
        break;

      case 12: // Managers
        const ManagersColumns = [
          {
            field: "id",
            headerName: "ID",
            flex: 0.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
          {
            field: "username",
            headerName: "Name",
            flex: 1.5,
            sortable: false,
            align: "left",
          },
          {
            field: "email",
            headerName: "Email",
            flex: 2,
            sortable: false,
            align: "left",
          },
          {
            field: "phoneNo",
            headerName: "Phone",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
          {
            field: "organization",
            headerName: "Organization",
            flex: 2,
            sortable: false,
            align: "left",
          },
          {
            field: "status",
            headerName: "Status",
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const isActive = params.row.is_active;
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${isActive
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                    }`}
                >
                  {isActive ? "Active" : "Inactive"}
                </span>
              );
            },
          },
          {
            field: "action",
            headerName: "Action",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const isActive = params.row.is_active;
              return (
                <Tooltip title={isActive ? "Deactivate" : "Activate"} placement="top">
                  <button
                    onClick={() => params.row.onStatusChange?.(params.row.id, !isActive)}
                    className={`p-2 rounded-md transition-colors duration-200 border ${isActive
                      ? "text-red-700 bg-red-50 hover:bg-red-100 border-red-300"
                      : "text-green-700 bg-green-50 hover:bg-green-100 border-green-300"
                      }`}
                  >
                    {isActive ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </button>
                </Tooltip>
              );
            },
          },
        ];
        setColumns(ManagersColumns);
        setRows(data);
        break;

      case 13: // Subscription Management
        const SubscriptionColumns = [
          {
            field: "organization",
            headerName: "Organization",
            flex: 2,
            sortable: false,
            align: "left",
          },
          {
            field: "manager_name",
            headerName: "Manager",
            flex: 1.5,
            sortable: false,
            align: "left",
          },
          {
            field: "email",
            headerName: "Email",
            flex: 2,
            sortable: false,
            align: "left",
          },
          {
            field: "plan_name",
            headerName: "Plan",
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const planName = params.row.plan_name;
              let colorClass = "bg-gray-100 text-gray-800";
              if (planName === "ULTIMATE") {
                colorClass = "bg-purple-100 text-purple-800";
              } else if (planName === "PREMIUM") {
                colorClass = "bg-blue-100 text-blue-800";
              } else if (planName === "BASIC") {
                colorClass = "bg-green-100 text-green-800";
              }
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${colorClass}`}
                >
                  {planName}
                </span>
              );
            },
          },
          {
            field: "subscription_end_date",
            headerName: "Renewal Date",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
          },
          {
            field: "subscription_status",
            headerName: "Status",
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const isActive = Boolean(params.row.is_active);
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${isActive
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                    }`}
                >
                  {isActive ? "Active" : "Inactive"}
                </span>
              );
            },
          },
          {
            field: "plan_changed_by",
            headerName: "Plan Changed By",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const changedBy = params.row.plan_changed_by;
              if (!changedBy) {
                return <span className="text-gray-400 text-xs">N/A</span>;
              }
              // Format the text: replace underscores with spaces and capitalize
              const formattedText = changedBy
                .replace(/_/g, " ")
                .split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(" ");
              const isSuperAdmin = formattedText.toLowerCase().includes("super admin");
              return (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${isSuperAdmin
                    ? "bg-blue-100 text-blue-800"
                    : "bg-purple-100 text-purple-800"
                    }`}
                >
                  {formattedText}
                </span>
              );
            },
          },
          {
            field: "actions",
            headerName: "Actions",
            flex: 1.5,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
              const isActive = params.row.is_active;
              return (
                <div className="flex gap-1 justify-center items-center px-2">
                  <Tooltip title="View Details" placement="top">
                    <button
                      onClick={() => params.row.onViewDetails && params.row.onViewDetails(params.row)}
                      className="p-1 text-[#1E3A8A] bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-md transition-all duration-200"
                    >
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        {ActionEye}
                      </div>
                    </button>
                  </Tooltip>
                  <Tooltip title="Change Plan" placement="top">
                    <button
                      onClick={() => params.row.onChangePlan(params.row)}
                      className="p-1 text-[#1E3A8A] bg-blue-50 hover:bg-blue-100 border border-[#1E3A8A] rounded-md transition-colors duration-200"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    </button>
                  </Tooltip>
                  <Tooltip title={isActive ? "Deactivate" : "Activate"} placement="top">
                    <button
                      onClick={() => params.row.onStatusChange(params.row, isActive ? 'deactivate' : 'activate')}
                      className={`p-1 rounded-md transition-colors duration-200 border ${isActive
                        ? "text-red-700 bg-red-50 hover:bg-red-100 border-red-300"
                        : "text-green-700 bg-green-50 hover:bg-green-100 border-green-300"
                        }`}
                    >
                      {isActive ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-3.5 w-3.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-3.5 w-3.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </button>
                  </Tooltip>
                </div>
              );
            },
          },
        ];
        setColumns(SubscriptionColumns);
        setRows(data);
        break;

      case 11: // Organization Members
        setColumns(OrganizationMembers);
        setRows(
          data?.map((item) => ({
            id: item?.id,
            username: item?.username,
            email: item?.email,
            role: item?.role,
            assignProject: item?.assignProject,
            numOfProjects: item?.numOfProjects,
            joinedDate: item?.joinedDate,
            status: item?.status,
            is_admin: item?.is_admin
          }))
        );
        break;

      default:
        setColumns([]);
        setRows([]);
        break;
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (data?.length) loadTable();
  }, [data]);

  const getDeleteMessage = () => {
    switch (index) {
      case 1:
        return "Do you really want to delete this university?";
      case 2:
        return "Do you really want to delete this post?";
      case 3:
        return "Do you really want to delete this project?";
      case 4:
        return "Do you really want to delete this worker?";
      case 5:
        return "Do you really want to delete this expense?";
      case 7:
        return "Do you really want to delete this community?";
      case 11:
        return "Do you really want to delete this member? This action cannot be undone.";
      default:
        return "Do you really want to delete this item?";
    }
  };

  return (
    <div>
      <ImagePreview
        imagePreviewUrl={previewData.image}
        videoUrl={previewData.video}
        description={previewData.description}
        closeImagePreview={closeModal}
        isPreviewOpen={isModalOpen}
        userProfile={previewData.userProfile}
        userName={previewData.userName}
        storyTime={previewData.storyTime}
      />
      <Modal open={open} onClose={handleClose}>
        <DailyStatsCalendar
          onClose={handleClose}
          OpenStats={() => setIsStatsOpen(true)}
          workerId={selectedWorkerId}
        />
      </Modal>

      <DailyStats
        open={isStatsOpen}
        onClose={() => setIsStatsOpen(false)}
        onBack={() => {
          setIsStatsOpen(false);
          setOpen(true);
        }}
        workerId={selectedWorkerId}
      />

      <UpgradePromptModal
        show={showUpgradeModal}
        handleClose={() => setShowUpgradeModal(false)}
        featureName="Worker Stats"
        requiredPlan="Basic"
      />

      <ConfirmationModal
        show={deleteModal}
        handleClose={() => setDeleteModal(false)}
        handleConfirm={() => {
          if (index === 11) { // Organization Members
            getData?.(deleteState); // This will trigger the delete handler in Organization.js
          } else {
            handleDelete(deleteState);
          }
          setDeleteModal(false);
          setDeleteState(null);
        }}
        loading={false}
        message={getDeleteMessage()}
      />

      {loader ? (
        <DataGridSkeleton
          totalRow={rows?.length || 10}
          totalCol={columns?.length || 10}
          image={false}
          header={columns}
        />
      ) : rows?.length === 0 || !data?.length ? (
        <div className="w-full h-[8rem] bg-white rounded-[4px] flex justify-center items-center">
          <p>No Data Found</p>
        </div>
      ) : (
        <div>
          <DataGrid
            style={{ backgroundColor: "white" }}
            sx={{
              '& .MuiDataGrid-cell': { color: '#000000' },
              '& .MuiDataGrid-columnHeaderTitle': { color: '#000000' },
              '& .MuiSvgIcon-root': { color: '#000000' },
              // Checkbox color and size
              '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root, & .MuiDataGrid-cellCheckbox .MuiCheckbox-root': {
                color: '#1E3A8A',
                padding: '0 4px'
              },
              '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked, & .MuiDataGrid-cellCheckbox .MuiCheckbox-root.Mui-checked': {
                color: '#1E3A8A !important'
              },
              '& .MuiDataGrid-columnHeaderCheckbox input[type="checkbox"]:checked + svg, & .MuiDataGrid-cellCheckbox input[type="checkbox"]:checked + svg': {
                color: '#1E3A8A !important',
                fill: '#1E3A8A !important'
              },
              '& .MuiDataGrid-columnHeaderCheckbox .MuiSvgIcon-root, & .MuiDataGrid-cellCheckbox .MuiSvgIcon-root': {
                fontSize: 18
              },
              // Try to thin the outline stroke on the checkbox icon path
              '& .MuiDataGrid-columnHeaderCheckbox .MuiSvgIcon-root path, & .MuiDataGrid-cellCheckbox .MuiSvgIcon-root path': {
                strokeWidth: 1
              }
            }}
            rows={rows}
            columns={columns}
            pagination={false}
            paginationMode={false}
            hideFooterPagination
            checkboxSelection={enableCheckboxSelection}
            disableRowSelectionOnClick={disableRowSelectionOnClick}
            rowSelectionModel={rowSelectionModel}
            onRowSelectionModelChange={onRowSelectionModelChange}
            getRowId={(row) => row.id}
            onRowClick={(params) => {
              if (index === 3 && isSuperAdmin) {
                handleProjectView(params.id);
              } else if (index === 10) {
                navigate("/super-admin/subscription-management", {
                  state: { organizationId: params.id }
                });
              }
            }}
            slots={toolbar ? {
              toolbar: () => (
                <div className="w-full flex items-center gap-3 px-3 py-2">
                  {toolbar}
                </div>
              )
            } : undefined}
          />
          {pagination && (
            <div className="flex justify-center mt-6">
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={onPageChange}
                showSizeChanger={true}
              />
            </div>
          )}
        </div>
      )}

      <ImageSlider
        visible={showImageSlider}
        onClose={() => setShowImageSlider(false)}
        images={selectedImages}
      />
    </div>
  );
};

export default DG;
